import type { Check } from "@/types";
import { Check as CheckIcon, X } from "lucide-react";

export function Checklist({ checks, onToggle, disabled }: { checks: Check[]; onToggle: (key: string, value: boolean) => void; disabled?: boolean }) {
  const manual = checks.filter((c) => !c.auto);
  const auto = checks.filter((c) => c.auto);
  return (
    <div data-testid="review-checklist">
      <p className="mb-2 text-xs font-bold uppercase tracking-[0.16em] text-[#23324A]/60">You check</p>
      <ul className="mb-5 space-y-2">
        {manual.map((c) => (
          <li key={c.key}>
            <label className={`flex cursor-pointer items-start gap-3 rounded-2xl border-2 px-3 py-3 transition-colors duration-150 ${c.ok ? "border-[#23324A] bg-[#F6D776]/60" : "border-[#23324A]/20 bg-white"}`}>
              <input type="checkbox" className="crayon-check mt-0.5" checked={c.ok} disabled={disabled}
                onChange={(e) => onToggle(c.key, e.target.checked)} data-testid={`check-${c.key}`} />
              <span className="text-sm font-semibold text-[#23324A]">{c.label}</span>
            </label>
          </li>
        ))}
      </ul>
      <p className="mb-2 text-xs font-bold uppercase tracking-[0.16em] text-[#23324A]/60">Checked for you</p>
      <ul className="space-y-1.5">
        {auto.map((c) => (
          <li key={c.key} className="flex items-center gap-2 text-sm text-[#23324A]" data-testid={`auto-check-${c.key}`}>
            <span className={`flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#23324A] ${c.ok ? "bg-[#B9E3C6]" : "bg-[#F08A6C]"}`}>
              {c.ok ? <CheckIcon className="h-3 w-3" strokeWidth={3.5} /> : <X className="h-3 w-3" strokeWidth={3.5} />}
            </span>
            {c.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
